"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _useCollapse2 = _interopRequireDefault(require("./useCollapse"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function Collapse(_ref) {
  var isOpen = _ref.isOpen,
      onRest = _ref.onRest,
      initialStyle = _ref.style,
      transition = _ref.transition,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["isOpen", "onRest", "style", "transition", "className"]);
  var content = (0, _react.useRef)(null);

  var _useCollapse = (0, _useCollapse2.default)({
    isOpen: isOpen,
    content: content
  }),
      setIsExpandedStyle = _useCollapse.setIsExpandedStyle,
      setIsCollapsedStyle = _useCollapse.setIsCollapsedStyle,
      style = _useCollapse.style;

  var onTransitionEnd = function onTransitionEnd(e) {
    if (e.target === content.current && e.propertyName === 'height') {
      if (isOpen) {
        setIsExpandedStyle();
      } else {
        setIsCollapsedStyle();
      }

      if (onRest) {
        onRest();
      }
    }
  };

  var styles = _objectSpread(_objectSpread({
    willChange: 'height',
    transition: transition
  }, initialStyle), style);

  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    ref: content,
    style: styles,
    className: className,
    onTransitionEnd: onTransitionEnd // eslint-disable-next-line react/jsx-props-no-spreading

  }, rest));
}

Collapse.defaultProps = {
  isOpen: false,
  onRest: null,
  style: null,
  className: 'react-css-collapse-transition',
  transition: 'height 250ms cubic-bezier(0.4, 0, 0.2, 1)'
};
Collapse.propTypes = {
  isOpen: _propTypes.bool,
  onRest: _propTypes.func,
  style: (0, _propTypes.shape)({}),
  className: _propTypes.string,
  transition: _propTypes.string
};
var _default = Collapse;
exports.default = _default;
//# sourceMappingURL=Collapse.js.map